<template>
  <component
    :is="tag"
    v-if="$slots.default"
    class="dn-grid"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
defineProps({
  tag: {
    type: String,
    required: false,
    default: 'section'
  }
});
</script>

<style lang="scss">
.dn-grid {
  --_dn-grid_grid-template: var(--dn-grid_grid-template, auto / 1fr);
  --_dn-grid_column-gap: var(--dn-grid_column-gap, var(--dn_column-gap, 12px));
  --_dn-grid_row-gap: var(--dn-grid_row-gap, var(--atlas_gap, 12px));
  --_dn-grid_inline-size: var(--dn-grid_inline-size,var(--grid-width));

  display: grid;
  grid-template: var(--_dn-grid_grid-template);
  gap: var(--_dn-grid_row-gap) var(--_dn-grid_column-gap);
  max-width: var(--_dn-grid_inline-size);

  > * {
    --_dn-grid-item_grid-column: var(--dn-grid-item_grid-column, auto);
    --_dn-grid-item_grid-row: var(--dn-grid-item_grid-row, auto);

    grid-column: var(--_dn-grid-item_grid-column);
    grid-row: var(--_dn-grid-item_grid-row);
  }
}
</style>
